export type TComponentValidator =
  | 'text'
  | 'json'
  | 'link'
  | 'youtube'
  | 'file'
  | 'spreadsheet';
export const isJSON = (str = '') => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const isLink = (str = '') => {
  let url;

  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const isYoutube = (str = '') => {
  // eslint-disable-next-line no-var
  var p =
    // eslint-disable-next-line no-regex-spaces
    /^(?:https?:\/\/)?(?:www\.)?    (?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  return str.match(p) ? true : false;
};

export const isSpreadsheet = (str = '') => {
  console.log('str', str);
  return true;
};

export const isValidDataType = (type, value) => {
  switch (type) {
    case 'text':
      return true;
    case 'json':
      return isJSON(value);
    case 'link':
      return isLink(value);
    case 'youtube':
      return isYoutube(value);
    case 'spreadsheet':
      return isSpreadsheet();
    default:
      return true;
  }
};

export const validateRegex = {
  // phone: /((\+84[0-9]{9})|(\b0[0-9]{9}))(?![0-9])/gs,
  phone: /(^840|^84)+([35789][0-9]{8})\b/g,
  password: /^(?=.*[a-z])(?=.*[0-9])(?=.*\d).{6,}$/g,
  username: /^(?=.{3,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+([_.])$/g,
  fullName: /^[a-z0-9 ]{3,100}$/iu,
  email:
    // eslint-disable-next-line
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  phoneFull: /(^840|^84|^0)+([35789][0-9]{8})$/,
  phoneHasPrefix: /([35789][0-9]{8})\b/g,
};
